import React from "react";

const Footer = ({ children, text, location = null, isBusinessGuide = true }) => {
  const isLandingAndConsumer = (!isBusinessGuide) && (location && location.pathname === "/guide");
  return (
    <footer className="footer">
      {children}
      <div className={`footer__content d-flex ${isLandingAndConsumer ? "justify-content-end" : "justify-content-center"} align-items-center`}>
        <div className="footer__text ">{text}</div>
        <div className="footer__logo" />
        <div className="footer__logoEqualHousing" />
      </div>
    </footer>
  );
};

export default Footer;
